//librerias
import { Component, Input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-modal-course-card",
  templateUrl: "./modal-course-card.component.html",
  styleUrls: ["./modal-course-card.component.css"],
})
export class ModalCourseCardComponent {
  @Input() data: any;
  title = "app";
  confirmacion: boolean = false;
  inscribir: boolean = false;
  procesandoInscripcion: boolean = false;
  success: boolean = false;
  failure: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  confirmacionFun() {
    this.confirmacion = !this.confirmacion;
  }

  cerrar() {
    this.activeModal.close();
  }

  inscribirse(peticionPrueba: boolean) {
    this.inscribir = !this.inscribir;

    setTimeout(() => {
      if (peticionPrueba) {
        this.success = !this.success;
      } else {
        this.failure = !this.failure;
      }
      this.procesandoInscripcion = !this.procesandoInscripcion;
    }, 4000);
  }
}
